import { render, staticRenderFns } from "./SaleSettings.vue?vue&type=template&id=5a86c83c"
import script from "./SaleSettings.vue?vue&type=script&lang=js"
export * from "./SaleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports